import { render, staticRenderFns } from "./CreatingRules.vue?vue&type=template&id=2ad88aa2&"
import script from "./CreatingRules.vue?vue&type=script&lang=js&"
export * from "./CreatingRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports